{
  "Ёж": [
    "ezh.svg"
  ],
  "Аксолотль": [
    "aksolotl.svg"
  ],
  "Аллигатор": [
    "alligator.svg"
  ],
  "Баклан": [
    "baklan.svg"
  ],
  "Барсук": [
    "barsuk.svg"
  ],
  "Бегемот": [
    "begemot.svg"
  ],
  "Белка": [
    "belka.svg"
  ],
  "Бизон": [
    "bizon.svg"
  ],
  "Бобр": [
    "bobr.svg"
  ],
  "Броненосец": [
    "bronenosec-1.svg",
    "bronenosec-2.svg"
  ],
  "Бурундук": [
    "burunduk.svg"
  ],
  "Верблюд": [
    "verblyud.svg"
  ],
  "Волк": [
    "volk.svg"
  ],
  "Вомбат": [
    "vombat.svg"
  ],
  "Ворон": [
    "voron.svg"
  ],
  "Выдра": [
    "vydra-1.svg",
    "vydra-2.svg"
  ],
  "Гепард": [
    "gepard.svg"
  ],
  "Гиена": [
    "giena.svg"
  ],
  "Гризли": [
    "grizli.svg"
  ],
  "Дельфин": [
    "delfin.svg"
  ],
  "Джекалоп": [
    "dzhekalop.svg"
  ],
  "Динго": [
    "dingo.svg"
  ],
  "Динозавр": [
    "dinozavr.svg"
  ],
  "Енот": [
    "enot.svg"
  ],
  "Жираф": [
    "zhiraf.svg"
  ],
  "Землеройка": [
    "zemleroyka.svg"
  ],
  "Игуана": [
    "iguana.svg"
  ],
  "Ифрит": [
    "ifrit.svg"
  ],
  "Капибара": [
    "kapibara.svg"
  ],
  "Квагга": [
    "kvagga.svg"
  ],
  "Кенгуру": [
    "kenguru.svg"
  ],
  "Коала": [
    "koala.svg"
  ],
  "Козерог": [
    "kozerog.svg"
  ],
  "Койот": [
    "koyot-1.svg",
    "koyot-2.svg"
  ],
  "Кот": [
    "kot.svg"
  ],
  "Кракен": [
    "kraken.svg"
  ],
  "Кролик": [
    "krolik.svg"
  ],
  "Лама": [
    "lama-1.svg",
    "lama-2.svg"
  ],
  "Ламантин": [
    "lamantin.svg"
  ],
  "Леопард": [
    "leopard-1.svg",
    "leopard-2.svg"
  ],
  "Лигр": [
    "ligr.svg"
  ],
  "Лис": [
    "lis.svg"
  ],
  "Лемур": [
    "lemur.svg"
  ],
  "Лори": [
    "lori.svg"
  ],
  "Лось": [
    "los-1.svg",
    "los-2.svg"
  ],
  "Лягушка": [
    "lyagushka.svg"
  ],
  "Морж": [
    "morzh.svg"
  ],
  "Муравьед": [
    "muraved.svg"
  ],
  "Мышь": [
    "mysh.svg"
  ],
  "Нарвал": [
    "narval.svg"
  ],
  "Норка": [
    "norka.svg"
  ],
  "Носорог": [
    "nosorog.svg"
  ],
  "Обезьяна": [
    "obezyana.svg"
  ],
  "Овца": [
    "ovca.svg"
  ],
  "Орангутан": [
    "orangutan.svg"
  ],
  "Панда": [
    "panda.svg"
  ],
  "Пингвин": [
    "pingvin.svg"
  ],
  "Питон": [
    "piton.svg"
  ],
  "Росомаха": [
    "rosomaha.svg"
  ],
  "Скунс": [
    "skuns-1.svg",
    "skuns-2.svg"
  ],
  "Слон": [
    "slon.svg"
  ],
  "Сова": [
    "sova.svg"
  ],
  "Суслик": [
    "suslik.svg"
  ],
  "Тигр": [
    "tigr.svg"
  ],
  "Тукан": [
    "tukan.svg"
  ],
  "Тур": [
    "tur.svg"
  ],
  "Утка": [
    "utka.svg"
  ],
  "Утконос": [
    "utkonos-1.svg",
    "utkonos-2.svg"
  ],
  "Хамелеон": [
    "hameleon.svg"
  ],
  "Хорёк": [
    "horek.svg"
  ],
  "Черепаха": [
    "cherepaha-1.svg",
    "cherepaha-2.svg",
    "cherepaha-3.svg"
  ],
  "Чупакабра": [
    "chupakabra-1.svg",
    "chupakabra-2.svg"
  ],
  "Шиншилла": [
    "shinshilla.svg"
  ],
  "Шакал": [
    "shakal-1.svg",
    "shakal-2.svg"
  ]
}
